import React from 'react';

const AuthButton = ({ children, onClick, type = 'button', fullWidth = true, variant = 'primary' }) => {
  const baseClasses = "py-2 px-4 rounded-md font-medium";
  
  const variantClasses = {
    primary: "bg-red-600 hover:bg-red-700 text-white",
    google: "bg-white hover:bg-gray-50 text-gray-700 border border-gray-300",
    facebook: "bg-blue-600 hover:bg-blue-700 text-white"
  };
  
  const widthClass = fullWidth ? "w-full" : "";
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${widthClass}`}
    >
      {children}
    </button>
  );
};

export default AuthButton;
